<template>
  <section ref="block" id="contact" class="container max-w-2xl p-5 sm:p-10 my-20 text-center border rounded-lg shadow scroll-m-[calc(var(--nav-bar-h)+5rem)]">
    <h2>{{ title }}</h2>

    <template v-if="!success">
      <slot v-bind="{ model }" />

      <UButton type="submit" size="xl" color="primary" @click="submitHandler" :loading="loading">Submit</UButton>
    </template>

    <template v-else>
      <UAlert
        color="green"
        title="Your message has been sent successfully!"
        description="Customer support will contact you as soon as possible (max. 12 hours)"
      />
    </template>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string
  mailSubject: string
}>()

const model = reactive<Record<string, any> & { email: string, Name: string }>({ email: '', Name: '' })

const loading = ref(false)
const success = ref(false)
const blockRef = useTemplateRef('block')

async function submitHandler () {
  try {
    loading.value = true

    console.log('Submitting form', {...model})
    await $fetch('/api/send-mail', {
      method: 'POST',
      body: { ...model, subject: props.mailSubject },
    })
    success.value = true
    blockRef.value?.scrollIntoView({ behavior: 'smooth' })
  } catch (e: any) {
    alert(`Error sending a message.\n\n${e.data.message}\n\nPlease try again or contact us at info@driveczech.com.`)
  } finally {
    loading.value = false
  }
}
</script>
